// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"98a7fe90","604":"bdb5611a","621":"34fc4888","905":"eb8bf05f"}[chunkId] + ".chunk.js";
};